import { SidebarMenuItem } from './SidebarMenuItem';
import icDashboard from '../../assets/icons/icons_navigation_24_home.svg';
import icCreditOpsDashboard from '../../assets/icons/ic_withdraw.svg';
import icPreviousLoan from '../../assets/icons/icons_navigation_24_history.svg';
import i18n from '../../utils/i18n';
import { isRoleBorrowerAgent, isRoleFinanceAgent, isRoleOpsAgent } from '../../constants/roles';
import { ISidebarMenu } from '../../hooks/SidebarMenuHook';
import { InvestmentFinanceRoutes } from '../../constants/routes';
import icRepayment from '../../assets/icons/icons_payments_24_send_money.svg';

const sideMenuItemsForBorrowerAgent = [
  new SidebarMenuItem(icDashboard, i18n.t('sidebar.createSubmission'), InvestmentFinanceRoutes.submissions),
  new SidebarMenuItem(icDashboard, i18n.t('sidebar.createSubmission'), InvestmentFinanceRoutes.createSubmission, { parentRoute: InvestmentFinanceRoutes.submissions }),
  new SidebarMenuItem(icDashboard, i18n.t('sidebar.createSubmission'), InvestmentFinanceRoutes.createSubmissionStep2, { parentRoute: InvestmentFinanceRoutes.submissions }),
  new SidebarMenuItem(icRepayment, i18n.t('sidebar.repayments'), InvestmentFinanceRoutes.repayments),
  new SidebarMenuItem(icPreviousLoan, i18n.t('previousLoans.title'), InvestmentFinanceRoutes.previousLoans),
  new SidebarMenuItem(icPreviousLoan, i18n.t('previousLoans.title'), InvestmentFinanceRoutes.uploadDocs, { parentRoute: InvestmentFinanceRoutes.previousLoans }),
];

const sideMenuItemsForFinanceAdmin: SidebarMenuItem[] = [];

const sideMenuItemsForCreditRiskOps: SidebarMenuItem[] = [
  new SidebarMenuItem(icCreditOpsDashboard, i18n.t('sidebar.disbursement'), InvestmentFinanceRoutes.submissionApproval),
  new SidebarMenuItem(
    icCreditOpsDashboard,
    i18n.t('sidebar.disbursement'),
    InvestmentFinanceRoutes.submissionApprovalWithId,
    { parentRoute: InvestmentFinanceRoutes.submissionApproval, fullPageWidth: true },
  ),
  new SidebarMenuItem(icPreviousLoan, i18n.t('sidebar.history'), InvestmentFinanceRoutes.loanHistory),
];

const investmentFinanceSidebarMenu = function getMenu(roles?: string[]): ISidebarMenu {
  let combinedMenu: SidebarMenuItem[] = [];
  if (isRoleBorrowerAgent(roles)) {
    combinedMenu = combinedMenu.concat(sideMenuItemsForBorrowerAgent);
  }
  if (isRoleFinanceAgent(roles)) {
    combinedMenu = combinedMenu.concat(sideMenuItemsForFinanceAdmin);
  }
  if (isRoleOpsAgent(roles)) {
    combinedMenu = combinedMenu.concat(sideMenuItemsForCreditRiskOps);
  }
  const distinctMenu = combinedMenu.filter(
    (item, index) => index === combinedMenu.findIndex(
      (menuItem) => menuItem.route === item.route,
    ),
  );
  return {
    filteredMenu: distinctMenu,
    borrowerAgentMenuList: sideMenuItemsForBorrowerAgent,
    financeAdminMenuList: sideMenuItemsForFinanceAdmin,
    creditOpsMenuList: sideMenuItemsForCreditRiskOps,
  };
};

export default investmentFinanceSidebarMenu;
